import { is_ie } from "../../common/functions/others";

const initializeNotificationMailSetting = () => {
  // IEの場合は実行しない & トグルボタンも非表示
  if (is_ie()) {
    const elem = document.querySelector("#jsMailNotificationToggle");
    elem.remove();
    return;
  }

  if (document.querySelector("#jsMailNotification")) {
    const search_conditon = $("#jsMailNotification").attr(
      "data-search-condition"
    );

    const notClickedForm = $("#jsMailNotification").find(
      "form:has(#not_clicked)"
    );
    notClickedForm.attr(
      "action",
      Routes.search_results_notification_mail_settings_path({
        search_params_json: search_conditon,
      })
    );

    $(".jsMailNotificationModal .jsMailNotificationHidden").val(
      search_conditon
    );
    $("#jsMailNotificationFacebook").attr(
      "person",
      JSON.stringify({ search_params_json: search_conditon })
    );

    fetch(Routes.async_info_notification_mail_setting_path())
      .then((response) => response.json())
      .then((data) => {
        const alreadySaved = data.notification_mail_settings.some(
          (e) => search_conditon == e.search_params_json
        );
        if (alreadySaved) {
          const setting = data.notification_mail_settings.find(
            (e) => search_conditon == e.search_params_json
          );
          $(
            `#jsMailNotification[data-search-condition='${setting.search_params_json}']`
          ).addClass("isClicked");

          const clickedForm = $("#jsMailNotification").find(
            "form:has(#clicked)"
          );
          clickedForm.attr(
            "action",
            Routes.people_search_results_notification_mail_setting_path(
              setting.id
            )
          );

          $("#jsMailNotification #clicked").prop("disabled", false);
        } else {
          $(
            `#jsMailNotification[data-search-condition='${search_conditon}']`
          ).removeClass("isClicked");
        }
      });
  }
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default initializeNotificationMailSetting;